export enum EnumLocalEstoque {
  Cabecalho = 1,
  Item
}

export const ListaLocalEstoque = [
  { descricao: "Cabecalho", valor: EnumLocalEstoque.Cabecalho },
  { descricao: "Item", valor: EnumLocalEstoque.Item }
];